module.exports = __webpack_public_path__ + "img/bg.82dd7f04.png";